class variantWidthHeight extends HTMLElement {
  constructor() {
    super();
    // Array que guarda os dados dos produtos
    this.productsCollection = window.productsCollection;

    // Selects de width e height
    this.selectWidth = this.querySelector('#select-width');
    this.selectHeight = this.querySelector('#select-height');
    this.hasRequiredSelectors = Boolean(this.selectWidth && this.selectHeight);

    // Inputs de id dos forms
    this.forProductVariantId = document.querySelector('.product-variant-id');
    this.formMotorVariantId = document.querySelector('.product-motor-id');
    this.formBandoVariantId = document.querySelector('.product-bando-id');

    // Msg error
    this.msgError = document.querySelector('.msg-error');

    // Button Submit form principal
    this.buttonSubmitForm = document.querySelector('.product-form__submit');

    // Querys Price
    this.divPriceDiscount = document.querySelector('.price__percentage-discount');
    if (this.divPriceDiscount) {
      this.comparetePrice = this.divPriceDiscount.querySelector('.price-item--regular');
      this.percentageDiscount = this.divPriceDiscount.querySelector('.percentage-discount');
    }
    this.priceSale = document.querySelector('.price-item--sale');
    this.quantityInstallment = document.querySelector('.quantity-installment');
    this.priceInstallment = document.querySelector('.price-installment');

    // Querys responsáveis pelo lado da Cordinha
    this.radiosSideRope = document.querySelectorAll('[name="lado-corda"]');
    this.arrayOfSideRope = Array.from(this.radiosSideRope);

    // Querys responsáveis pelo Comando
    this.containerCommand = this.querySelector('.container-comando');
    this.spanPriceCommand = this.querySelector('.price-drive-motorized');
    this.radiosMotor = document.querySelectorAll('[name="drive"]');
    this.arrayOfMotor = Array.from(this.radiosMotor);

    // Querys responsáveis pela opção do motor se a bateria ou elétrico
    this.containerOptionMotor = document.querySelector('.option-motor');
    this.radiosOptionMotor = document.querySelectorAll('[name="option-type-motor"]');
    this.arrayOfOptionMotor = Array.from(this.radiosOptionMotor);

    // Querys responsáveis pela opção de voltagem do motor
    this.containerVoltage = document.querySelector('.voltage');
    this.radiosVoltage = document.querySelectorAll('[name="voltage"]');
    this.arrayVoltage = Array.from(this.radiosVoltage);

    // Querys responsáveis pelo Bando
    this.containerBando = this.querySelector('.container-bando');
    this.radiosBando = document.querySelectorAll('[name="bando"]');
    this.arrayBando = Array.from(this.radiosBando);
    this.spanPriceBando = this.querySelector('.price-bando');

    // Inputs Properties
    this.propertieWidth = document.querySelector('.propertie-width');
    this.propertieHeight = document.querySelector('.propertie-height');
    this.propertieSideRope = document.querySelector('.propertie-side-rope');
    this.propertieMotor = document.querySelector('.propertie-motor');
    this.propertieFromPersiana = document.querySelector('.propertie-from-persiana');
    this.propertieFromPersianaBando = document.querySelector('.propertie-from-persiana-bando');
    this.propertieFromPersianaBandoLargura = document.querySelector('.propertie-from-persiana-bando-largura');
    this.propertieFromPersianaMotorLargura = document.querySelector('.propertie-from-persiana-motor-largura');
    this.propertieFinishing = document.querySelector('.propertie-finishing');

    // Items summary
    this.containerSummary = document.querySelector('.container-summary');
    this.widthSummary = document.querySelector('.select-width__summary');
    this.heightSummary = document.querySelector('.select-height__summary');
    this.difWidthSup = document.querySelector('.dif-width-sup__summary');
    this.depth = document.querySelector('.depth__summary');
    this.specificationDepths = document.querySelectorAll('.fp-product-specifications__depth-value');
    this.containerCharged = document.querySelector('.container-charged');
    this.areaMinCharged = document.querySelector('.area-min-charged__summary');
    this.shippingTime = document.querySelector('.shipping-time__summary');

    this.firstLineHowMeasure = document.querySelector('.how-measure__first_line__summary');
    this.secondLineHowMeasure = document.querySelector('.how-measure__second_line__summary');
    this.linkHowMeasure = document.querySelector('.how-measure__link__summary');

    this.firstLineHowInstall = document.querySelector('.how-install__first_line__summary');
    this.secondLineHowInstall = document.querySelector('.how-install__second_line__summary');
    this.link1HowInstall = document.querySelector('.how-measure__link1__summary');
    this.tertiaryLineHowInstall = document.querySelector('.how-install__tertiary_line__summary');
    this.link2HowInstall = document.querySelector('.how-measure__link2__summary');

    //Events
    if (this.selectWidth) {
      this.selectWidth.addEventListener('change', () => {
        this.setProductId();
        this.optionMotor();
      });
    }
    if (this.selectHeight) {
      this.selectHeight.addEventListener('change', () => {
        this.setProductId();
        this.optionMotor();
      });
    }
    if (this.radiosSideRope) {
      this.radiosSideRope.forEach((item) => {
        item.addEventListener('change', () => {
          this.updateDataChecked(this.arrayOfSideRope);
          this.getSetSideOfRope();
        });
      });
    }
    if (this.radiosMotor) {
      this.radiosMotor.forEach((item) => {
        item.addEventListener('change', () => {
          this.updateDataChecked(this.arrayOfMotor);
          this.optionMotor();
        });
      });
    }
    if (this.radiosOptionMotor) {
      this.radiosOptionMotor.forEach((item) => {
        item.addEventListener('change', () => {
          this.updateDataChecked(this.arrayOfOptionMotor);
          if (item.value == 'elétrico') {
            window.bateria = false;
            window.voltage = 220;
          } else {
            window.bateria = true;
            window.voltage = 'A bateria';
          }
          this.selectMotorVariant(window.areaPersiana, window.bateria, window.voltage);
          this.optionMotor();
        });
      });
    }
    if (this.radiosVoltage) {
      this.radiosVoltage.forEach((item) => {
        item.addEventListener('change', () => {
          this.updateDataChecked(this.arrayVoltage);
          let voltage = item.value === '220v' ? 220 : 110;
          window.voltage = voltage;
          this.selectMotorVariant(window.areaPersiana, window.bateria, window.voltage);
          this.optionMotor();
        });
      });
    }
    if (this.radiosBando) {
      this.radiosBando.forEach((item) => {
        item.addEventListener('change', () => {
          this.updateDataChecked(this.arrayBando);
          this.getSetBando();
        });
      });
    }
  }

  connectedCallback() {
    if (!this.hasRequiredSelectors || this.getMeasureProducts().length === 0) return;

    this.loopOptions(this.selectWidth, this.getMinWidth(), this.getMaxWidth());
    this.loopOptions(this.selectHeight, this.getMinHeight(), this.getMaxHeight());
    this.setProductId();
    this.setDataCheckedLoadPage(this.arrayOfSideRope, 1);
    this.getSetSideOfRope();
    this.setDataCheckedLoadPage(this.arrayOfMotor, 0);
    this.optionMotor();
    this.setDataCheckedLoadPage(this.arrayOfOptionMotor, 1);
    this.setDataCheckedLoadPage(this.arrayVoltage, 0);
    window.bateria = true;
    window.voltage = 'A bateria';
    this.setDataCheckedLoadPage(this.arrayBando, 0);
    this.selectMotorVariant(window.areaPersiana, window.bateria, window.voltage);
    this.getSetBando();
    if (this.spanPriceBando) this.setInitialBandoValue();
    // Adicionando chamada para processar a URL na inicialização
    this.processUrlVariant();
  }

  setSubmitButtonLabel(label) {
    const labelElement =
      this.buttonSubmitForm?.querySelector('[data-atc-label]') || this.buttonSubmitForm?.querySelector('span');
    if (labelElement) labelElement.textContent = label;
  }

  // Funções responsável por pegar os dados dentro da Array Product List
  getMeasureProducts() {
    if (!Array.isArray(this.productsCollection)) return [];

    return this.productsCollection.filter(
      (product) => product.product_type === 'persiana_principal' || product.product_type === 'persiana_secundaria'
    );
  }

  getMinWidth() {
    const filteredProducts = this.getMeasureProducts();
    if (filteredProducts.length > 0) {
      let minWidth = filteredProducts[0].min_width;

      for (const obj of filteredProducts) {
        if (obj.min_width < minWidth) {
          minWidth = obj.min_width;
        }
      }
      return minWidth;
    } else {
      console.log('Error no window.productsCollection. Isso quer dizer que há erro nos cadastros dos produtos');
    }
  }
  getMaxWidth() {
    const filteredProducts = this.getMeasureProducts();
    if (filteredProducts.length > 0) {
      let maxWidth = filteredProducts[0].max_width;

      for (const obj of filteredProducts) {
        if (obj.max_width > maxWidth) {
          maxWidth = obj.max_width;
        }
      }
      return maxWidth;
    } else {
      console.log('Error no window.productsCollection. Isso quer dizer que há erro nos cadastros dos produtos');
    }
  }
  getMinHeight() {
    const filteredProducts = this.getMeasureProducts();
    if (filteredProducts.length > 0) {
      let minHeight = filteredProducts[0].min_height;

      for (const obj of filteredProducts) {
        if (obj.min_height < minHeight) {
          minHeight = obj.min_height;
        }
      }
      return minHeight;
    } else {
      console.log('Error no window.productsCollection. Isso quer dizer que há erro nos cadastros dos produtos');
    }
  }
  getMaxHeight() {
    const filteredProducts = this.getMeasureProducts();
    if (filteredProducts.length > 0) {
      let maxHeight = filteredProducts[0].max_height;

      for (const obj of filteredProducts) {
        if (obj.max_height > maxHeight) {
          maxHeight = obj.max_height;
        }
      }
      return maxHeight;
    } else {
      console.log('Error no window.productsCollection. Isso quer dizer que há erro nos cadastros dos produtos');
    }
  }

  // Função responsável por formar as options nos selects de largura ou altura
  loopOptions(selectElement, min, max) {
    if (!selectElement || !Number.isFinite(min) || !Number.isFinite(max)) return;

    // Preserva a primeira opção e remove as demais
    const opcoesExistentes = selectElement.options.length;
    for (let i = opcoesExistentes - 1; i > 0; i--) {
      // Começa de trás para frente, preservando a primeira opção
      selectElement.remove(i);
    }

    // Gera e adiciona novas options após a primeira opção existente
    // Incrementa de 10 em 10 (1 cm)
    for (let mm = min + 10; mm <= max; mm += 10) {
      // Converte para metros
      const valorEmMetros = mm / 1000;
      const option = document.createElement('option');
      option.value = mm;
      // Formata a string
      if (window.typeMeasure === 'm_cm') {
        option.textContent = `${valorEmMetros.toFixed(2)} m (${mm / 10} cm)`;
      } else {
        option.textContent = `${valorEmMetros.toFixed(2)} m (${mm} mm)`;
      }
      selectElement.appendChild(option);
    }
  }

  // Atualiza o item selecionado com o atributo data-checked
  updateDataChecked(array) {
    if (!array) return;

    array.forEach((radio) => {
      if (radio.checked) {
        radio.setAttribute('data-checked', '');
      } else {
        radio.removeAttribute('data-checked');
      }

      // Verofica se a opção de Motor Elétrico está ativo. Se tiver adiciona regras
      if (radio.defaultValue === 'elétrico') {
        if (radio.hasAttribute('data-checked')) {
          if (this.containerVoltage) this.containerVoltage.classList.add('active');
        } else {
          if (this.containerVoltage) this.containerVoltage.classList.remove('active');
        }
      }
    });
    this.optionMotor();
  }

  // Quando carraga a página seta o atributo data-checked no lado direito da Cordinha
  setDataCheckedLoadPage(array, indexArray) {
    if (array && array[indexArray]) {
      array[indexArray].setAttribute('data-checked', '');
    }
  }

  // Função responsável por capturar o valor do item checked e setar o valor na propertie da cordinha
  getSetSideOfRope() {
    if (!this.propertieSideRope) return;
    // Procura o item checked e seta o valor na propertie
    const checkedRadio = this.arrayOfSideRope.find((radio) => radio.hasAttribute('data-checked'));

    // Seta o valor do item checked na propertie
    if (checkedRadio) {
      this.propertieSideRope.value = checkedRadio.value;
    } else {
      console.log('Nenhum lado da cordinha foi selecionado');
    }
  }

  // Função responsável por capturar o valor do item checked e setar o valor na propertie do bando
  getSetBando() {
    if (!this.propertieFinishing) return;
    // Procura o item checked e seta o valor na propertie
    const checkedRadio = this.arrayBando.find((radio) => radio.hasAttribute('data-checked'));

    // Seta o valor do item checked na propertie
    if (checkedRadio) {
      this.propertieFinishing.value = checkedRadio.value;
    } else {
      console.log('Nenhum lado da cordinha foi selecionado');
    }
  }

  // Atualiza a propriedade do motor baseada nas seleções de inputs radio
  optionMotor() {
    if (!this.propertieMotor) return;
    // Encontra o radio selecionado no grupo de 'drive'
    const checkedDrive = this.arrayOfMotor.find((radio) => radio.hasAttribute('data-checked'));

    // Encontra o radio selecionado no grupo de 'option-type-motor'
    const checkedOptionTypeMotor = this.arrayOfOptionMotor.find((radio) => radio.hasAttribute('data-checked'));

    // Encontra o radio selecionado no grupo de 'voltage'
    const checkedVoltage = this.arrayVoltage.find((radio) => radio.hasAttribute('data-checked'));

    // Compondo o valor baseado nas seleções
    let finalValue = '';
    if (checkedDrive) {
      finalValue += checkedDrive.value;

      // Verifica se 'motorizado' foi selecionado e adiciona os valores correspondentes
      if (checkedDrive.value === 'Motorizado') {
        if (this.containerOptionMotor) this.containerOptionMotor.classList.add('active');

        if (checkedOptionTypeMotor) {
          // Ajuste aqui: apenas inclui o valor de 'voltage' se 'elétrico' for selecionado
          if (checkedOptionTypeMotor.value === 'elétrico') {
            if (this.containerVoltage) this.containerVoltage.classList.add('active');
            if (checkedVoltage) {
              // Modificação: Remove a palavra 'elétrico' do valor final
              finalValue = `Motorizado (${checkedVoltage.value})`;
            }
          } else {
            // Para outros valores (como 'bateria'), inclui no valor final normalmente
            finalValue += ` (${checkedOptionTypeMotor.value})`;
            if (this.containerVoltage) this.containerVoltage.classList.remove('active');
          }
        }
      } else {
        // Se 'motorizado' não foi selecionado, esconde os containers
        if (this.containerOptionMotor) this.containerOptionMotor.classList.remove('active');
        if (this.containerVoltage) this.containerVoltage.classList.remove('active');
      }
    } else {
      console.log('Nenhuma opção de drive foi selecionada');
    }

    // Atualiza o valor do input do formulário
    this.propertieMotor.value = finalValue;
  }

  // Seta no span this.spanPriceBando o valor da primeira variante do Bando
  setInitialBandoValue() {
    if (!Array.isArray(this.productsCollection)) return;

    const bandoProduct = this.productsCollection.find((product) => product.product_type === 'bando');
    if (bandoProduct && Array.isArray(bandoProduct.variants) && bandoProduct.variants.length > 0) {
      const firstVariant = bandoProduct.variants[0];
      const spanBando = this.spanPriceBando;
      if (spanBando) {
        // Ou outro atributo conforme necessário
        spanBando.innerHTML = firstVariant.price;
      }
    }
  }

  // Funções responsáveis por pegar o id da variável (gerada pela combintação dos selects de largura e altura) e setar esse id no form de produto.
  selectProductId() {
    const products = this.getMeasureProducts();
    if (products.length === 0) return null;

    let closestMatch = null;
    let closestProduct = null;
    let smallestDiff = Infinity;
    // Seleção da largura feita pelo usuário que não vai sofrer alterações na função.
    let selectedUserWidth = +this.selectWidth.value;
    // Seleção da largura que vai sofrer as modificações para achar o match da variante da persiana.
    let selectedWidth = +this.selectWidth.value;
    // Seleção da altura feita pelo usuário que não vai sofrer alterações na função.
    let selectedUserHeight = +this.selectHeight.value;
    // Seleção da altura que vai sofrer as modificações para achar o match da variante da persiana.
    let selectedHeight = +this.selectHeight.value;
    // Pega o valor da largura da persiana e seta na span correspondente no summary
    if (this.widthSummary) this.widthSummary.innerHTML = this.mmTometer(selectedUserWidth);

    // Pega o valor da altura da persiana e seta na span correspondente no summary
    if (this.heightSummary) this.heightSummary.innerHTML = this.mmTometer(selectedUserHeight);

    // Inicializa variáveis para rastrear se alguma variante satisfaz as condições de largura e altura
    let widthAvailable = false;
    let heightAvailable = false;

    products.forEach((product) => {
      if (Array.isArray(product.variants)) {
        product.variants.forEach((variant) => {
          const widthDiff = variant.width - selectedWidth;
          const heightDiff = variant.height - selectedHeight;

          // Verifica se a variante satisfaz a condição de largura ou altura
          if (widthDiff >= 0) {
            widthAvailable = true;
          }
          if (heightDiff >= 0) {
            heightAvailable = true;
          }

          // Se satisfizer ambas as condições, verifica se é a combinação mais próxima
          if (widthDiff >= 0 && heightDiff >= 0) {
            const totalDiff = widthDiff + heightDiff;
            if (totalDiff < smallestDiff) {
              closestMatch = variant;
              smallestDiff = totalDiff;
              // Aqui salvamos a referência ao produto atual, que contém a variante mais próxima
              closestProduct = product;
            }
          }
        });
      }
    });

    if (!closestMatch) {
      if (this.msgError) this.msgError.classList.add('active');
      if (this.buttonSubmitForm) {
        this.buttonSubmitForm.setAttribute('disabled', '');
        this.setSubmitButtonLabel('PRODUTO INDISPONÍVEL');
      }
      if (this.forProductVariantId) this.forProductVariantId.value = 0;
      if (this.formMotorVariantId) this.formMotorVariantId.value = 0;

      // Retira a classe active do summary caso closestMatch seja false
      if (this.containerSummary) this.containerSummary.classList.remove('active');

      // Se não encontrou uma variante compatível, identifica qual dimensão está faltando
      if (widthAvailable && heightAvailable) {
        console.log(
          `Nenhuma variante compatível encontrada para as dimensões selecionadas - Largura: ${selectedWidth}, Altura: ${selectedHeight}`
        );
      } else if (widthAvailable) {
        console.log(
          `Nenhuma variante compatível encontrada para a largura selecionada: ${selectedWidth}. Por favor, selecione outra largura.`
        );
      } else if (heightAvailable) {
        console.log(
          `Nenhuma variante compatível encontrada para a altura selecionada: ${selectedHeight}. Por favor, selecione outra altura.`
        );
      }
      return null;
    }

    // Regras de Price
    const price = closestMatch.price;
    const priceFormated = this.formatarComoReais(price);

    if (this.priceSale) this.priceSale.innerHTML = priceFormated;

    if (closestMatch.compare_at_price !== 'Não existe') {
      const compareAtPrice = closestMatch.compare_at_price;
      const compareAtPriceFormated = this.formatarComoReais(compareAtPrice);
      if (this.comparetePrice) this.comparetePrice.innerHTML = compareAtPriceFormated;

      const valueDiscount = this.calcularDesconto(closestMatch.compare_at_price, closestMatch.price);
      if (this.percentageDiscount) this.percentageDiscount.innerHTML = `-${valueDiscount}%`;
    }

    const resultInstallment = this.calcularParcelamento(closestMatch.price);
    const valorParcela = this.formatarComoReais(resultInstallment.valorParcela);
    if (this.quantityInstallment) this.quantityInstallment.innerHTML = `${resultInstallment.quantidadeParcelas}x`;
    if (this.priceInstallment) this.priceInstallment.innerHTML = valorParcela;

    // Expõe o valor da área no window
    window.areaPersiana = closestMatch.area;

    // Regras do button form
    if (this.buttonSubmitForm) {
      this.buttonSubmitForm.removeAttribute('disabled');
      this.setSubmitButtonLabel('ADICIONAR AO CARRINHO');
    }

    // Regras Msg Error
    if (this.msgError) this.msgError.classList.remove('active');

    // Set propertie Persiana
    if (this.propertieFromPersiana) {
      this.propertieFromPersiana.value = closestProduct.title;
    }
    if (this.propertieFromPersianaBando) {
      this.propertieFromPersianaBando.value = closestProduct.title;
    }

    // Regras para option_motor
    if (closestMatch.option_motor === true) {
      if (this.containerCommand) this.containerCommand.classList.remove('disabled');
      if (this.arrayOfMotor && this.arrayOfMotor[1]) this.arrayOfMotor[1].checked = false;
    } else {
      if (this.containerCommand) this.containerCommand.classList.add('disabled');
      if (this.arrayOfMotor && this.arrayOfMotor[0]) this.arrayOfMotor[0].setAttribute('data-checked', '');
      if (this.arrayOfMotor && this.arrayOfMotor[1]) this.arrayOfMotor[1].removeAttribute('data-checked');
    }

    // Regras para option_bando
    if (closestMatch.option_bando === true) {
      if (this.containerBando) this.containerBando.classList.remove('disabled');
      // this.arrayOfMotor[1].checked = false; // This line seems out of place here in original too
    } else {
      // Original logic had containerCommand here, maybe a typo in original? keeping it as is but defensive
      if (this.containerCommand) this.containerCommand.classList.add('disabled');
      if (this.arrayOfMotor && this.arrayOfMotor[0]) this.arrayOfMotor[0].setAttribute('data-checked', '');
      if (this.arrayOfMotor && this.arrayOfMotor[1]) this.arrayOfMotor[1].removeAttribute('data-checked');
    }

    // Regras para mandatory_motor
    if (closestMatch.mandatory_motor === true) {
      if (this.arrayOfMotor && this.arrayOfMotor[0]) {
        this.arrayOfMotor[0].setAttribute('disabled', '');
        this.arrayOfMotor[0].removeAttribute('data-checked');
      }
      if (this.arrayOfMotor && this.arrayOfMotor[1]) {
        this.arrayOfMotor[1].setAttribute('data-checked', '');
      }
    } else {
      if (this.arrayOfMotor && this.arrayOfMotor[0]) this.arrayOfMotor[0].removeAttribute('disabled');
    }

    if (window.areaPersiana !== undefined && window.bateria !== undefined && window.voltage !== undefined) {
      this.selectMotorVariant(window.areaPersiana, window.bateria, window.voltage);
    }

    // Implementação para encontrar a variante de bando
    let bandoVariant = this.selectBandoVariant(closestMatch.width);
    if (bandoVariant) {
      // Asumindo que existe um input para isso
      if (this.formBandoVariantId) this.formBandoVariantId.value = bandoVariant.id;
      if (this.spanPriceBando) this.spanPriceBando.innerHTML = bandoVariant.price;
    }

    // Mostra o summary caso closestMatch seja true
    if (closestMatch && this.containerSummary) {
      this.containerSummary.classList.add('active');
    }

    // Pega a largura selecionada e subtrai menos o valor do metafield (2 - [ERP - CBB] INFO Diferenca entre largura e suporte e tecido da persiana (mm)) da variante selecionada e seta no span Largura do tecido no summary
    this.setFabricWidthSummary(selectedUserWidth, closestMatch, closestProduct);

    // Pega a profundidade da variante selecionada e seta no resumo e na PDP Specs
    this.setDepthSummary(closestMatch, closestProduct);

    // Pega o valor da largura e altura selecionada pelo usuário e divide 1000000. Se o valor for menor que o metafield  [ERP - CBB] INFO Área Minima Cobrada (metro quadrado) então mostra o container charged
    let multWidthHeight = (selectedUserWidth * selectedUserHeight) / 1000000;

    if (closestProduct.area_min_charged !== 'Metafield não preenchido') {
      if (multWidthHeight < closestProduct.area_min_charged) {
        if (this.containerCharged) this.containerCharged.classList.add('active');
        if (closestProduct.area_min_charged_text !== 'Metafield não preenchido') {
          if (this.areaMinCharged) this.areaMinCharged.innerHTML = closestProduct.area_min_charged_text;
        } else {
          console.log(
            `O metafield (5 - [CBB] INFO Área Minima Cobrada - aviso) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
          );
        }
      } else {
        if (this.containerCharged) this.containerCharged.classList.remove('active');
      }
    } else {
      console.log(
        `O metafield (5 - [ERP - CBB] INFO Área Minima Cobrada (metro quadrado)) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
      );
    }

    // Pega o valor do metafield 8 - [CBB] INFO Tempo de produção - texto descritivo da variante e joga no span Tempo de envio no summary
    if (closestMatch.shipping_time_text !== 'Metafield não preenchido') {
      if (this.shippingTime) this.shippingTime.innerHTML = closestMatch.shipping_time_text;
    } else {
      console.log(
        `O metafield (8 - [CBB] INFO Tempo de produção - texto descritivo) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
      );
    }

    // Pega o valor do metafield [CBB] INFO Como Medir (rich text) e joga na div how measure no summary
    if (closestProduct.how_measure !== 'Metafield não preenchido' && closestProduct.how_measure) {
      if (this.firstLineHowMeasure) this.firstLineHowMeasure.innerHTML = closestProduct.how_measure.first_line;
      if (this.secondLineHowMeasure) this.secondLineHowMeasure.innerHTML = closestProduct.how_measure.second_line;
      if (this.linkHowMeasure) {
        this.linkHowMeasure.innerHTML = closestProduct.how_measure.text_link;
        this.linkHowMeasure.setAttribute('href', closestProduct.how_measure.link);
      }
    } else {
      console.log(
        `O metafield (8 - [CBB] INFO Tempo de produção - texto descritivo) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
      );
    }

    // Pega o valor do metafield 10 - [CBB] INFO Como Instalar (rich text) e joga na na div how install no summary
    if (closestProduct.how_install !== 'Metafield não preenchido' && closestProduct.how_install) {
      if (this.firstLineHowInstall) this.firstLineHowInstall.innerHTML = closestProduct.how_install.first_line;
      if (this.secondLineHowInstall) this.secondLineHowInstall.innerHTML = closestProduct.how_install.second_line;
      if (this.link1HowInstall) {
        this.link1HowInstall.innerHTML = closestProduct.how_install.text_link_1;
        this.link1HowInstall.setAttribute('href', closestProduct.how_install.link_1);
      }
      if (this.tertiaryLineHowInstall) this.tertiaryLineHowInstall.innerHTML = closestProduct.how_install.tertiary_line;
      if (this.link2HowInstall) {
        this.link2HowInstall.innerHTML = closestProduct.how_install.text_link_2;
        this.link2HowInstall.setAttribute('href', closestProduct.how_install.link_2);
      }
    } else {
      console.log(
        `O metafield (8 - [CBB] INFO Tempo de produção - texto descritivo) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
      );
    }

    return closestMatch.id;
  }

  setProductId() {
    if (!this.selectWidth || !this.selectHeight) return;

    const selectedWidth = +this.selectWidth.value;
    const selectedHeight = +this.selectHeight.value;

    // Verifica se ambos os selects têm valores selecionados
    if (selectedWidth > 0 && selectedHeight > 0) {
      // Quando os dois valores de largura e altura são maiores que zero, seta as propriedades do produto;
      this.setValuePropertie(this.propertieWidth, this.selectWidth);
      this.setValuePropertie(this.propertieHeight, this.selectHeight);
      // Seta o valor da largura do produto na propriedade Largura no Bando
      this.setValuePropertie(this.propertieFromPersianaBandoLargura, this.selectWidth);
      // Seta o valor da largura do produto na propriedade Largura no Motor
      this.setValuePropertie(this.propertieFromPersianaMotorLargura, this.selectWidth);

      // Aqui chama sua função selectProductId e atualiza o formulário com o retorno
      const variantId = this.selectProductId();

      if (variantId && this.forProductVariantId) {
        this.forProductVariantId.value = variantId;
      }
    } else {
      if (this.forProductVariantId) this.forProductVariantId.value = 0;
      if (this.formMotorVariantId) this.formMotorVariantId.value = 0;
      // Retira a classe active do summary caso não seja setado algum produto
      if (this.containerSummary) this.containerSummary.classList.remove('active');
      // Põe novamente a classe disabled nos containers de bando e motor
      if (this.containerCommand) this.containerCommand.classList.add('disabled');
      if (this.containerBando) this.containerBando.classList.add('disabled');
    }
  }

  // Função responsável por escolher o motor
  selectMotorVariant(area, isBattery, voltage) {
    if (!Array.isArray(this.productsCollection) || area === undefined || area === null) return null;

    let motorArea = area <= 5 ? 5.1 : 12;
    const motorVariants = this.productsCollection.filter((product) => product.product_type === 'motor');

    let selectedMotorVariant = null;

    motorVariants.forEach((motor) => {
      if (!Array.isArray(motor.variants)) return;

      motor.variants.forEach((variant) => {
        if (variant.area === motorArea && variant.bateria === isBattery && variant.voltage === voltage) {
          selectedMotorVariant = variant;
        }
      });
    });

    if (selectedMotorVariant) {
      // Supondo que você tenha um formulário ou input específico para o ID do motor
      if (this.formMotorVariantId) this.formMotorVariantId.value = selectedMotorVariant.id;
      if (this.spanPriceCommand) this.spanPriceCommand.innerHTML = selectedMotorVariant.price;
      return selectedMotorVariant.id;
    } else {
      console.log('Nenhum motor compatível encontrado.');
      return null;
    }
  }

  // Função responsável por escolher o bando
  selectBandoVariant(persianaWidth) {
    if (!Array.isArray(this.productsCollection)) return null;

    const bandoProduct = this.productsCollection.find((product) => product.product_type === 'bando');
    let closestBando = null;
    let smallestDiff = Infinity;

    if (bandoProduct !== undefined && Array.isArray(bandoProduct.variants)) {
      bandoProduct.variants.forEach((variant) => {
        let widthDiff = Math.abs(variant.width - persianaWidth);
        if (widthDiff < smallestDiff) {
          smallestDiff = widthDiff;
          closestBando = variant;
        }
      });
    }

    return closestBando;
  }

  // Função responsável por pegar o value dos selects. Retorna uma string.
  getValueSelect(element) {
    return element ? element.value : '';
  }

  // Função responsável por setar values na propertie setada.
  setValuePropertie(propertie, element) {
    if (!propertie || !element) return;

    propertie.value = this.getValueSelect(element);
  }

  toNumber(value) {
    if (typeof value === 'number') return Number.isFinite(value) ? value : null;
    if (typeof value !== 'string') return null;

    const normalizedValue = value.replace(',', '.').replace(/[^\d.-]/g, '');
    if (normalizedValue === '') return null;

    const parsedValue = Number(normalizedValue);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  getFabricWidthDifference(closestMatch, closestProduct) {
    const directDifference = this.toNumber(closestMatch?.dif_width_sup);
    if (directDifference !== null) return directDifference;

    if (!closestProduct || !Array.isArray(closestProduct.variants)) return null;

    const closestVariantWidth = this.toNumber(closestMatch?.width);
    if (closestVariantWidth !== null) {
      const sameWidthVariant = closestProduct.variants.find((variant) => {
        return (
          this.toNumber(variant.width) === closestVariantWidth &&
          this.toNumber(variant.dif_width_sup) !== null
        );
      });
      if (sameWidthVariant) return this.toNumber(sameWidthVariant.dif_width_sup);
    }

    const differences = closestProduct.variants
      .map((variant) => this.toNumber(variant.dif_width_sup))
      .filter((difference) => difference !== null);
    const uniqueDifferences = new Set(differences);

    return uniqueDifferences.size === 1 ? differences[0] : null;
  }

  setFabricWidthSummary(selectedUserWidth, closestMatch, closestProduct) {
    if (!this.difWidthSup) return;

    const supportWidth = this.toNumber(selectedUserWidth);
    const bracketFabricDifference = this.getFabricWidthDifference(closestMatch, closestProduct);

    if (supportWidth === null || bracketFabricDifference === null) {
      this.difWidthSup.textContent = '';
      console.log(
        `O metafield (2 - [ERP - CBB] INFO Diferenca entre largura e suporte e tecido da persiana (mm)) do produto ${closestProduct?.title} e variant ${closestMatch?.title} não foi preenchido`
      );
      return;
    }

    const fabricWidth = supportWidth - bracketFabricDifference;
    if (fabricWidth <= 0) {
      this.difWidthSup.textContent = '';
      console.log(
        `O cálculo da largura do tecido retornou valor inválido para o produto ${closestProduct?.title} e variant ${closestMatch?.title}`
      );
      return;
    }

    this.difWidthSup.textContent = this.mmTometer(fabricWidth);
  }

  getVariantDepth(closestMatch, closestProduct) {
    const directDepth = this.toNumber(closestMatch?.depth);
    if (directDepth !== null) return directDepth;

    if (!closestProduct || !Array.isArray(closestProduct.variants)) return null;

    const closestVariantWidth = this.toNumber(closestMatch?.width);
    if (closestVariantWidth !== null) {
      const sameWidthVariant = closestProduct.variants.find((variant) => {
        return this.toNumber(variant.width) === closestVariantWidth && this.toNumber(variant.depth) !== null;
      });
      if (sameWidthVariant) return this.toNumber(sameWidthVariant.depth);
    }

    const depths = closestProduct.variants
      .map((variant) => this.toNumber(variant.depth))
      .filter((depth) => depth !== null);
    const uniqueDepths = new Set(depths);

    return uniqueDepths.size === 1 ? depths[0] : null;
  }

  setDepthSummary(closestMatch, closestProduct) {
    const depth = this.getVariantDepth(closestMatch, closestProduct);
    if (depth !== null) {
      const formattedDepth = this.mmTometer(depth);
      if (this.depth) this.depth.innerHTML = formattedDepth;
      this.specificationDepths.forEach((depthElement) => {
        depthElement.innerHTML = formattedDepth;
      });
      return;
    }

    if (this.depth) this.depth.innerHTML = '';
    this.specificationDepths.forEach((depthElement) => {
      depthElement.innerHTML = '';
    });
    console.log(
      `O metafield (3 - [ERP - CBB] INFO Profundidade Persiana (mm)) do produto ${closestProduct.title} e variant ${closestMatch.title} não foi preenchido`
    );
  }

  //Função responsável por transformar mm para metro
  mmTometer(mm) {
    const millimeters = Number(mm);
    if (!Number.isFinite(millimeters)) return '';

    return `${(millimeters / 1000).toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })} m`;
  }

  // Função formatação valor em Reais
  formatarComoReais(valor) {
    // Dividir por 100 para converter centavos em reais
    const valorEmReais = valor / 100;

    // Formatar o número como moeda usando a localidade 'pt-BR' para Real brasileiro
    const valorFormatado = valorEmReais.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return valorFormatado;
  }

  // Função que calcula o desconto
  calcularDesconto(valorOriginal, valorComDesconto) {
    // Calcular a diferença absoluta
    const diferenca = valorOriginal - valorComDesconto;

    // Calcular a porcentagem de desconto
    const porcentagemDesconto = (diferenca / valorOriginal) * 100;

    // Arredondar para o inteiro mais próximo
    return Math.round(porcentagemDesconto);
  }

  // Funçõa calculo parcelamento
  calcularParcelamento(valor) {
    // Definir a quantidade de parcelas fixas em 12x
    const quantidadeParcelas = 12;

    // Aplicar 11% de juros ao valor total
    const juros = 0.11;
    const valorComJuros = valor * (1 + juros);

    // Calcular o valor de cada parcela
    let valorParcela = valorComJuros / quantidadeParcelas;

    // Determinar se o valor da parcela é um número inteiro e formatar adequadamente
    valorParcela = Number.isInteger(valorParcela) ? valorParcela : valorParcela.toFixed(2);

    return {
      quantidadeParcelas: quantidadeParcelas,
      valorParcela: valorParcela,
    };
  }

  // Nova função para processar o parâmetro 'variant' na URL
  processUrlVariant() {
    if (!Array.isArray(this.productsCollection) || !this.selectWidth || !this.selectHeight) return;

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has('variant')) {
      const variantId = urlParams.get('variant');
      let foundVariant = null;

      this.productsCollection.forEach((product) => {
        if (!Array.isArray(product.variants)) return;

        product.variants.forEach((variant) => {
          if (variant.id == variantId) {
            foundVariant = variant;
          }
        });
      });

      if (foundVariant) {
        this.selectWidth.value = foundVariant.width;
        this.selectHeight.value = foundVariant.height;
        this.setProductId();
      }
    }
  }
}

if (!customElements.get('variant-width-height')) {
  customElements.define('variant-width-height', variantWidthHeight);
}
